import * as React from 'react';
import { ReactElement } from 'react';

const IconCheck = ({ ...props }): ReactElement => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <title lang="en">Check mark</title>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5905 3.193C22.0362 3.51911 22.1332 4.1448 21.8071 4.59053L10.1012 20.5905C9.94056 20.8101 9.69734 20.9548 9.42768 20.9911C9.15802 21.0274 8.8852 20.9523 8.67214 20.7831L2.37802 15.7831C1.94558 15.4395 1.8735 14.8105 2.21703 14.3781C2.56056 13.9456 3.18961 13.8735 3.62205 14.2171L9.10146 18.5699L20.193 3.40961C20.5191 2.96388 21.1448 2.8669 21.5905 3.193Z"
        fill="#381FD1"
      />
    </svg>
  );
};

export default IconCheck;
